import React from "react";
import ReactDOM from "react-dom";
import "./globals.sass"
import "./styleguide.sass"
import App from "./App";

ReactDOM.render(<App />, document.getElementById("app"));